import * as Logger from './logger';

/* eslint-disable @typescript-eslint/no-explicit-any */

const domPurify = (window as any).DOMPurify || {};

export function sanitizeValue(value: any): any {
  if (typeof value === 'string') {
    /* istanbul ignore next if */
    if (typeof domPurify.sanitize !== 'function') {
      Logger.warn('sanitizeConsentParameters', 'DOMPurify is not available, value will NOT be sanitized');
      return value;
    }
    return domPurify.sanitize(value);
  } else if (value instanceof Array) {
    return value.map((entry) => sanitizeValue(entry));
  } else if (value instanceof Object) {
    const sanitizedObj: { [key: string]: any } = {};
    for (const prop in value) {
      /* istanbul ignore next else */
      if (Object.prototype.hasOwnProperty.call(value, prop)) {
        sanitizedObj[prop] = sanitizeValue(value[prop]);
      }
    }
    return sanitizedObj;
  } else {
    return value;
  }
}
